goog.provide('el8.appchart.letters.relatedAttachmentsPrompt');

goog.require('el8.template.appchart.letters.relatedAttachmentsPrompt');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.NewDialog');


/**
 * This dialog gets used by selectAttachments when a user attaches a primary document
 * that references secondary documents. Given a list of attachments, it will
 * show a dialog asking the user to attach all or none of them. It does not currently
 * let the user pick a subset to attach, although they can delete any subset of the new
 * items back in the main selectAttachments dialog.
 *
 * The dialog accepts two forms of attachments as input:
 *  1. the object soy maps (for stuff like reports referenced by a visit note)
 *      - These get fed into clientGeneratedAttachmentSummary
 *  2. attachment soy maps (for attachments from another letter)
 *      - These get fed into savedAttachmentSummary
 */
el8.appchart.letters.relatedAttachmentsPrompt = (function() {

    var callbackFn = null; // the callback to run if the user says "yes"

    var that = new el8.uiwidget.NewDialog({
        title: 'Additional Attachments',
        modal: true,
        position: 'center',
        autoHeight: true,
        width: 450
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton('yes', 'Yes', function() {
        if (callbackFn) { callbackFn(); }
        that.hide();
    });
    buttonSet.addButton('cancel', 'No', 
        function() { that.hide(); }
    );
    that.setButtonSet(buttonSet);

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        callbackFn = spec.callbackFn;

        super_show.call(that);
        that.setContent(
            el8.template.appchart.letters.relatedAttachmentsPrompt.content({
                documentSoyMaps: spec.documentSoyMaps || [],
                attachmentSoyMaps: spec.attachmentSoyMaps || []
            })
        );
        that.adjustHeight();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        callbackFn = null;
    };

    return that;

})();